import * as React from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import './rvChart.css';

interface ChartActionPillProps {
    // the figure the pill is about ("83"); it is bold inside the sentence
    count: React.ReactNode;
    onClick: () => void;
    children: React.ReactNode;
}

// A count under a chart that opens the matching list when clicked ("83 phone messages yet to be responded to"). One centred pill with a
// chevron, so it reads as something to press, unlike the quiet limit note. Display only; the figure and the click are the chart's own.
export const ChartActionPill: React.FC<ChartActionPillProps> = ({ count, onClick, children }) => (
    <div className="rv-chart-action-row">
        <button type="button" className="rv-chart-action" onClick={onClick}>
            <b>{count}</b>
            <span>{children}</span>
            <ChevronRightIcon fontSize="small" />
        </button>
    </div>
);
